import { render, staticRenderFns } from "./addTestimonial.vue?vue&type=template&id=2de5bc3c&"
import script from "./addTestimonial.vue?vue&type=script&lang=js&"
export * from "./addTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./addTestimonial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports